// src/components/global/CartDropdown.tsx
"use client";

import React, { useState, useEffect } from "react";

interface CartDropdownProps {
  children: React.ReactNode;
}

const CartDropdown: React.FC<CartDropdownProps> = ({ children }) => {
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsAtTop(window.scrollY === 0);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`dropdown-menu-right cart-menu ${isAtTop ? "home-top" : ""}`}
      style={{ position: "absolute" }}
    >
      {children}
    </div>
  );
};

export default CartDropdown;